// Lib
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, withProps } from '../../../../../../node_module_clones/recompose';

// Selectors
import { isUserSubscribed } from '../../../../../user/currentUserSelector';
import {
    emptyOtherUserTrashSelector,
    trashedByOtherUsersElementIdsSelector,
    trashedByOtherUsersOrderedListContentSelector,
    trashedByOtherUsersOrderedListIdsSelector,
    trashFetchedSelector,
    trashFetchingSelector,
    trashHasMoreSelector,
    trashHasOlderSelector,
} from '../../store/trashSelector';

// Actions
import { fetchNextPageOfTrash, fetchTrash } from '../../store/trashActions';

// Components
import TrashPopupOthersEmptyPlaceholder from './TrashPopupOthersEmptyPlaceholder';
import TrashPopupGenericTab from './TrashPopupGenericTab';

// Constants
import { TRASH_TABS } from '../../store/trashConstants';
import { WORKSPACE_SECTIONS } from '../../../../workspaceConstants';

const mapStateToProps = createStructuredSelector({
    isEmptyTrash: emptyOtherUserTrashSelector,
    trashListOrderedContent: trashedByOtherUsersOrderedListContentSelector,
    trashListContentIds: trashedByOtherUsersOrderedListIdsSelector,
    hasMore: trashHasMoreSelector(TRASH_TABS.OTHERS),
    hasOlder: trashHasOlderSelector(TRASH_TABS.OTHERS),
    trashFetched: trashFetchedSelector(TRASH_TABS.OTHERS),
    trashFetching: trashFetchingSelector(TRASH_TABS.OTHERS),
    currentUserIsSubscribed: isUserSubscribed,
    trashElementIds: trashedByOtherUsersElementIdsSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchTrash: () => dispatch(fetchTrash({ tab: TRASH_TABS.OTHERS })),
    dispatchLoadMoreTrash: () => dispatch(fetchNextPageOfTrash({ tab: TRASH_TABS.OTHERS })),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withProps(() => ({
        PlaceholderComponent: TrashPopupOthersEmptyPlaceholder,
        section: WORKSPACE_SECTIONS.TRASH_OTHERS,
    })),
);

export default enhance(TrashPopupGenericTab);
